import { Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EventStatusEnum } from "../../_common/enum/forms/eventStatus.enum";
import { IFilteringViewModel } from "../../_common/interface/table";
import '../../_common/styles/calendar.css';
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { getDate } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { eventService } from "../../_services/event.service";

var { Calendar, CalendarControls } = require('react-yearly-calendar');

export function UserProfileEventList(params: { owner?: string }) {
    const navigate = useNavigate();
    const { userId } = useParams<{ userId: string }>();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);

    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });
    const [customClasses, setCustomClasses] = useState({
        holidays: [],
        spring: {
            // start: '2018-03-21',
            // end: '2018-6-20'
        },
        summer: {
            // start: '2018-06-21',
            // end: '2018-09-22'
        },
        autumn: {
            // start: '2018-09-23',
            // end: '2018-12-21'
        },
        weekend: 'Sat,Sun',
        //winter: function (day: any) { return day.isBefore(moment([2018, 2, 21])) || day.isAfter(moment([2018, 11, 21])) }
    });

    useEffect(() => {
        fetchData();
    }, [filter, params.owner]);

    function fetchData() {
        if (!userId) return;

        setLoading(true);
        return eventService.getAll({ ...filter })
            .then(
                (json) => {
                    setData(json);
                    setCustomClasses((_classes) => { return { ..._classes, holidays: json.items.map((item: any) => moment(item.eventDate).format("YYYY-MM-DD")) } });
                }
            )
            .finally(() => setLoading(false));
    }

    function viewDetails(id: number) {
        navigate("View/" + id)
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'eventStatusId',
                header: 'Status',
                accessorFn: (rowData: any) => <>{EventStatusEnum[rowData.eventStatusId].toString()}</>
            },
            {
                accessorKey: 'price',
                header: 'Price',
                accessorFn: (rowData: any) => <>{getMoneyFormat(rowData.price)}</>
            },
            {
                accessorKey: 'eventDate',
                header: 'Event Date',
                accessorFn: (rowData: any) => <>{getDate(rowData.eventDate)}</>
            },
        ],
        [],
    );
    return (
        <>
            {/* <PageHeader
                pageName="Racing Events Calendar"
                actionType="create"
            />

            <Paper className={"annualCalendar"}>
                <Calendar
                    firstDayOfWeek={1}
                    customClasses={customClasses}
                    year={new Date().getFullYear()}
                />
            </Paper>
<br/>
<br/> */}
            <PageHeader
                pageName="Racing Events"
                actionType="create"
            />

            <Paper sx={{ marginTop: "8px" }}>
                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                    onView={(d) => { viewDetails(Number(d)) }}
                />
            </Paper>
        </>
    );
}